<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" (click)="close.emit()">
  <div class="bg-white rounded-xl shadow-lg p-6 max-w-md w-full relative" (click)="$event.stopPropagation()">
    <h2 class="modal-title mb-2">Cargar Orden</h2>
    <p class="text-sm text-gray-500 mb-4">
      Sube el archivo xls o xlsx correspondiente a la orden de compra.
    </p>

    <!--Archivo-->
    <div class="border-2 border-dashed border-blue-400 rounded-lg p-6 text-center flex flex-col items-center mb-6"> 
      <span class="material-symbols-outlined text-5xl text-blue-400 mb-2">description</span>
      <p class="text-gray-600 mb-1">Sube el documento de la orden de compra.</p>
      <p class="text-xs text-gray-400 mb-4">Solo se acepta formato xls o xlsx.</p>
      <input type="file" accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
             (change)="onFileSelected($event)" class="hidden" #xlsInput />
      <button class="px-4 py-2 upload-modal-button" (click)="xlsInput.click()">
        Seleccionar archivo
      </button>
      <p *ngIf="fileName" class="mt-3 text-sm text-gray-700">
        Archivo seleccionado: <strong>{{ fileName }}</strong>
      </p>
    </div>
    <div class="flex justify-end mt-6 gap-3">
      <button class="px-4 py-2 cancel-modal-button" (click)="close.emit()">
        Cancelar
      </button> 
      <button class="px-4 py-2 upload-modal-button isabled:opacity-50" [disabled]="!xlsFile" (click)="uploadFile()">
        Subir archivos
      </button>
    </div>
  </div>
</div>